export enum WorkOrderServiceReviewStatuses {
  NO_WARNING = 'no_warning',
  WARNING = 'warning',
  ADJUSTED = 'adjusted',
  APPROVED = 'approved',
  AUTO_APPROVED = 'auto_approved'
}
